/**
 * A player the logged-in user has shared at least one match with.
 *
 * The backend frequently returns empty `name`/`surnames` and a null `level`
 * for players that were only ever added to a match by email and never
 * completed their profile, so every accessor here degrades to the email.
 */
export class CommunityPlayer {
  constructor(
    readonly email: string,
    readonly name: string,
    readonly surnames: string,
    readonly img: string | null,
    readonly level: number | null,
    readonly competitiveMatches: number
  ) {}

  get fullName(): string {
    return [this.name, this.surnames]
      .map((part) => part.trim())
      .filter((part) => part.length > 0)
      .join(" ");
  }

  get hasName(): boolean {
    return this.fullName.length > 0;
  }

  /** What to render as the row title: the real name, or the email as fallback. */
  get displayName(): string {
    return this.hasName ? this.fullName : this.email;
  }

  /** Letter shown in the avatar placeholder when the player has no picture. */
  get initial(): string {
    return this.displayName.charAt(0).toUpperCase();
  }
}
